/**
 * AccountSelect — seletor de conta único das páginas de Marketing (topbar).
 * Só aparece com mais de uma conta.
 */
import { AccountFilter } from './Filters.jsx'

export default function AccountSelect({ accounts, selected, onChange }) {
  if (!accounts || accounts.length < 2) return null
  return <AccountFilter accounts={accounts} selected={selected} onChange={onChange} compact />
}
